function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["queryConfig"],
  _excluded2 = ["queryConfig"],
  _excluded3 = ["queryConfig"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { useCreateRecordBase, useFindRecordBase, useUpdateRecordBase, useQueryBase, usePopulateBase } from '@unite-us/json-api-resources';
import { useMutation, useQuery } from 'react-query';
import { coreApi } from './config';
export var usePopulate = function usePopulate(relationshipName, modelName, data) {
  var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _params$queryConfig = params.queryConfig,
    queryConfig = _params$queryConfig === void 0 ? {} : _params$queryConfig,
    rest = _objectWithoutProperties(params, _excluded);
  return usePopulateBase(relationshipName, modelName, data, _objectSpread(_objectSpread({}, rest), {}, {
    api: coreApi,
    useQuery: useQuery,
    queryConfig: _objectSpread({
      enabled: true
    }, queryConfig)
  }));
};
export var useFindRecord = function useFindRecord(modelName, id) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _params$queryConfig2 = params.queryConfig,
    queryConfig = _params$queryConfig2 === void 0 ? {} : _params$queryConfig2,
    rest = _objectWithoutProperties(params, _excluded2);
  return useFindRecordBase(modelName, id, _objectSpread(_objectSpread({}, rest), {}, {
    api: coreApi,
    useQuery: useQuery,
    queryConfig: _objectSpread({
      enabled: true
    }, queryConfig)
  }));
};
export var useFind = function useFind(modelName, query) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _params$queryConfig3 = params.queryConfig,
    queryConfig = _params$queryConfig3 === void 0 ? {} : _params$queryConfig3,
    rest = _objectWithoutProperties(params, _excluded3);
  return useQueryBase(modelName, query, _objectSpread(_objectSpread({}, rest), {}, {
    api: coreApi,
    useQuery: useQuery,
    queryConfig: _objectSpread({
      enabled: true
    }, queryConfig)
  }));
};
export var useCreateRecord = function useCreateRecord(modelName) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var callback = useCreateRecordBase({
    useMutation: useMutation,
    mutationConfig: _objectSpread({}, options.mutationConfig)
  });
  var mutateAsync = callback.mutateAsync;
  callback.mutate = null;
  callback.mutateAsync = null;
  callback.createRecord = function (data) {
    var overrideOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var newData = {
      model: modelName,
      data: data,
      params: _objectSpread(_objectSpread({}, overrideOptions.jsonApiParams), {}, {
        api: coreApi
      })
    };
    return mutateAsync(newData, overrideOptions.mutationConfig);
  };
  return callback;
};
export var useUpdateRecord = function useUpdateRecord(modelName) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var callback = useUpdateRecordBase({
    useMutation: useMutation,
    mutationConfig: options.mutationConfig
  });
  var mutateAsync = callback.mutateAsync;
  callback.mutate = null;
  callback.mutateAsync = null;
  callback.updateRecord = function (id, data) {
    var overrideOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var newData = {
      model: modelName,
      id: id,
      data: data,
      params: _objectSpread(_objectSpread({}, overrideOptions.jsonApiParams), {}, {
        api: coreApi
      })
    };
    return mutateAsync(newData, overrideOptions.mutationConfig);
  };
  return callback;
};
//# sourceMappingURL=ApiHooks.js.map